<template>
<div class="newsList content">
  <ul v-loading="loading">
    <li v-for="item in list">
      <router-link :to="{name: 'newsDetail', params: {id: item.gwNewsId}}">
        <i><b>{{$parseTime(item.issueTime, '{d}')}}</b>{{$parseTime(item.issueTime, '{y}.{m}')}}</i>
        <dl>
          <dt><img :src="item.imgUrl"></dt>
          <dd>{{item.title}}</dd>
        </dl>
      </router-link>
    </li>
  </ul>
  <div class="pages content">
    <a href="javascript:;" class="next" v-if="current !== 1" @click="goto(current-1)">上一页</a>
    <a :class="{on: current === i}" href="javascript:;" v-if="pages > 1" v-for="i in pages" :key="i" @click="goto(i)">{{i}}</a>
    <a href="javascript:;" class="prev" v-if="pages && current !== pages" @click="goto(current+1)">下一页</a>
  </div>
</div>
</template>

<script>
import { newsPageFind } from '@/api'
export default {
  data() {
    return {
      loading: false,
      list: [],
      pageSize: 6,
      current: 1,
      pages: 0
    }
  },
  created() {
    this.renderList(this.current)
  },
  methods: {
    renderList(current) {
      this.loading = true
      newsPageFind({ channel: 3, type: 1, pageSize: this.pageSize, current }).then(res => {
        if (res.success) {
          this.list = (res.data.records || [])
          this.pages = res.data.pages || 0
          this.current = current
        }
      }).catch(() => {
        this.list = []
        this.pages = 0
      }).finally(_ => {
        this.loading = false
      })
    },
    goto(page) {
      this.renderList(page)
    }
  }
}
</script>
